module.exports = __webpack_public_path__ + "img/2-hublot-block-1.647c909b.png";